export function toggleWatchLaterAPI(id) {
  if(process.env.NODE_ENV === 'development') {
    return {
      success: true
    };
  }

  const formData = new FormData();
  formData.append('action', 'class_watch_later_flag');
  formData.append('class_id', id);

  return fetch(window.dataWP.config.endpoints.ajax_url, {
    method: 'POST',
    body: formData
  })
    .then((res) => res.json())
    .catch((e) => false);
}
